import React from "react";
import ReactDom from "react-dom";
import "../css/CompletionModal.css";

const CompletionModal = ({
  open,
  closeCompletion,
  closePreview,
  setFormInfo,
  children,
}) => {
  if (!open) return null;

  if (open === true) {
    return ReactDom.createPortal(
      <>
        <div
          className="overlay"
          onClick={() => {
            closeCompletion();
            closePreview();
            setFormInfo({
              observeInput: "",
              feelInput: "",
              needInput: "",
              offerInput: "",
              requestInput: "",
            });
          }}
        />

        <div className="CompletionModal">{children}</div>
      </>,
      document.getElementById("portal")
    );
  }
};

export default CompletionModal;
